(ns core.front.operation-registry
  "Pure registry of in-flight operations, keyed by operation id.

  The registry lives under a single app-db key mapping operation ids to opaque metadata.
  Operations are started with metadata, read back while active, and settled (removed) by id.
  Re-registering an id replaces its metadata, so a chained request can take the operation over.")

(defn start-operation
  "Registers `operation-id` as an active operation with the given `metadata`. Re-registering
   an id replaces its metadata, so a chained request can take the operation over."
  [db operation-id metadata]
  (assoc-in db [::operations operation-id] metadata))

(defn active-operations
  "The active operations as a {operation-id metadata} map."
  [db]
  (get db ::operations {}))

(defn operation
  "The metadata of the active `operation-id`; nil when it is not registered."
  [db operation-id]
  (get (active-operations db) operation-id))

(defn settle-operation
  "Removes `operation-id` from the active operations."
  [db operation-id]
  (update db ::operations (fnil dissoc {}) operation-id))
